(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aft-home-visual"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (window.aftHeroV004) {
    window.aftHeroV004.mount(document);
    return;
  }
  var instances = new WeakMap();
  function heroesWithin(scope) {
    var items = Array.from(scope.querySelectorAll('.afth-hero[data-afth-version="v004"]'));
    if (scope.matches && scope.matches('.afth-hero[data-afth-version="v004"]')) items.unshift(scope);
    return items;
  }
  function init(hero) {
    if (instances.has(hero)) return;
    var controller = new AbortController();
    var signal = controller.signal;
    var stage = hero.querySelector('.afth-hero-stage');
    var spots = Array.from(hero.querySelectorAll('.afth-spot'));
    var image = hero.querySelector('.afth-hero-img');
    var active = null;
    var press = null;
    var recentTouch = null;
    var imageTimer = 0;
    function listen(target, type, listener, options) {
      target.addEventListener(type, listener, Object.assign({}, options || {}, { signal: signal }));
    }
    function closeAll() {
      spots.forEach(function (spot) {
        spot.classList.remove('is-active');
        spot.setAttribute('aria-expanded', 'false');
      });
      active = null;
    }
    function open(spot) {
      closeAll();
      active = spot;
      spot.classList.add('is-active');
      spot.setAttribute('aria-expanded', 'true');
    }
    function nearest(x, y) {
      var result = null;
      var shortest = Infinity;
      spots.forEach(function (spot) {
        var rect = spot.getBoundingClientRect();
        if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) return;
        var dx = x - (rect.left + rect.width / 2);
        var dy = y - (rect.top + rect.height / 2);
        var distance = dx * dx + dy * dy;
        if (distance < shortest) {
          shortest = distance;
          result = spot;
        }
      });
      return result;
    }
    function spotForEvent(event) {
      var card = event.target.closest && event.target.closest('.afth-spot-card');
      if (card && stage.contains(card)) return card.closest('.afth-spot');
      return nearest(event.clientX, event.clientY);
    }
    function isTouch(event) {
      return event.pointerType === 'touch' || event.pointerType === 'pen';
    }
    spots.forEach(function (spot) {
      listen(spot, 'pointerenter', function (event) {
        if (!isTouch(event)) open(spotForEvent(event) || spot);
      });
      listen(spot, 'pointerleave', function (event) {
        if (!isTouch(event) && document.activeElement !== spot && !spot.contains(event.relatedTarget)) closeAll();
      });
      listen(spot, 'focus', function () {
        if (!press && !(recentTouch && Date.now() - recentTouch.time < 800)) open(spot);
      });
      listen(spot, 'blur', function () {
        if (active === spot) closeAll();
      });
    });
    listen(stage, 'pointermove', function (event) {
      if (isTouch(event)) return;
      var spot = spotForEvent(event);
      if (spot && spot !== active) open(spot);
      else if (!spot && !spots.includes(document.activeElement)) closeAll();
    });
    listen(stage, 'pointerleave', function (event) {
      if (!isTouch(event) && !spots.includes(document.activeElement)) closeAll();
    });
    listen(stage, 'pointerdown', function (event) {
      if (!isTouch(event) || !event.isPrimary) return;
      var spot = spotForEvent(event);
      press = {
        id: event.pointerId,
        spot: spot,
        x: event.clientX,
        y: event.clientY,
        time: Date.now()
      };
    }, { capture: true, passive: true });
    listen(stage, 'pointerup', function (event) {
      if (!isTouch(event) || !press || event.pointerId !== press.id) return;
      var start = press;
      press = null;
      event.preventDefault();
      event.stopPropagation();
      recentTouch = { time: Date.now(), x: event.clientX, y: event.clientY };
      var distance = Math.hypot(event.clientX - start.x, event.clientY - start.y);
      if (distance > 12 || Date.now() - start.time > 900) {
        closeAll();
        return;
      }
      var spot = spotForEvent(event);
      if (!spot || spot !== start.spot) {
        closeAll();
        return;
      }
      // Both the yellow dot and its card follow the same category in one tap.
      window.location.assign(spot.href);
    }, { capture: true });
    listen(stage, 'pointercancel', function (event) {
      if (press) {
        recentTouch = { time: Date.now(), x: event.clientX, y: event.clientY };
        closeAll();
      }
      press = null;
    }, { capture: true });
    listen(stage, 'click', function (event) {
      if (event.detail === 0) return;
      if (recentTouch && Date.now() - recentTouch.time <= 800 && Math.hypot(event.clientX - recentTouch.x, event.clientY - recentTouch.y) <= 24) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      var spot = spotForEvent(event);
      if (spot && event.target.closest('.afth-spot') !== spot) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (event.ctrlKey || event.metaKey || event.shiftKey) window.open(spot.href, '_blank', 'noopener');
        else window.location.assign(spot.href);
      }
    }, { capture: true });
    listen(stage, 'auxclick', function (event) {
      if (event.button !== 1) return;
      var spot = spotForEvent(event);
      if (spot && event.target.closest('.afth-spot') !== spot) {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.open(spot.href, '_blank', 'noopener');
      }
    }, { capture: true });
    listen(document, 'pointerdown', function (event) {
      if (!hero.contains(event.target)) {
        press = null;
        closeAll();
      } else if (!stage.contains(event.target)) {
        closeAll();
      }
    }, { capture: true, passive: true });
    listen(stage, 'click', function (event) {
      if (!event.target.closest('.afth-spot')) closeAll();
    });
    listen(document, 'keydown', function (event) {
      if (event.key === 'Escape') {
        press = null;
        closeAll();
      }
    });
    function imageFailed() {
      closeAll();
      hero.classList.add('is-img-failed');
    }
    function checkImage() {
      if (image && image.complete && image.naturalWidth === 0) imageFailed();
    }
    if (image) {
      listen(image, 'error', imageFailed);
      listen(image, 'load', function () {
        if (image.naturalWidth > 0) hero.classList.remove('is-img-failed');
        else imageFailed();
      });
      checkImage();
      imageTimer = window.setTimeout(checkImage, 2500);
    }
    hero.classList.add('afth-ready');
    instances.set(hero, function () {
      controller.abort();
      window.clearTimeout(imageTimer);
      closeAll();
      hero.classList.remove('afth-ready');
      instances.delete(hero);
    });
  }
  function mount(scope) { heroesWithin(scope).forEach(init); }
  function unmount(scope) {
    heroesWithin(scope).forEach(function (hero) {
      var destroy = instances.get(hero);
      if (destroy) destroy();
    });
  }
  window.aftHeroV004 = { mount: mount, unmount: unmount };
  document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { unmount(event.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mount(document); }, { once: true });
  }
  mount(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
